import React from "react";
import LanguageSelector from "../LanguageSelector";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

function Header() {
  const { pathname } = useLocation(); // Get the current path

  const username = sessionStorage.getItem("username");
  const firstName = sessionStorage.getItem("first_name") || "";
  const lastName = sessionStorage.getItem("last_name") || "";
  const { t } = useTranslation();
  const logoSrc =
    pathname === "/" ? "/home-page-logo.svg" : "/inner-page-logo.svg";

  const role = sessionStorage.getItem("role");
  const isHomePage = pathname === "/" || pathname === "/course";
  const isMobileOrTablet = window.innerWidth < 1024; // Checking for mobile/tablet screens

  return (
    <div className="w-full md:flex justify-between items-center">
      <div className="flex items-center justify-between gap-5">
        {/* <div>
          <img src={welcomLogo} alt="logo" className="w-16 h-16" />
        </div> */}
        <div>
          <img
            src={logoSrc}
            alt="logo"
            className={`${
              pathname === "/" ? "w-[20rem] h-[7rem]" : "w-16 h-16"
            }`}
          />
        </div>
        <div className="flex flex-col justify-end items-end md:items-start md:justify-start w-full ml-12">
          <p className="text-2xl font-semibold text-[#ac112d] text-left w-full">
            {t("Welcome")}
          </p>
          <p className="text-lg font-light text-[#ac112d] text-left w-full">
            {firstName + " " + lastName || t("Unknown")}
          </p>
        </div>
      </div>
      <div>
        {role && !isHomePage && !isMobileOrTablet && (
          <p className="text-lg font-semibold text-[#ac112d] flex items-center justify-end min-w-[180px] pr-4">
            {/* {t("Logged In")} as {t(role)} */}
            {role === "Admin" && t("Admin View")}
            {role === "Learner" && t("Learner View")}
            {role === "Manager" && t("Manager View")}
            {role === "HR" && t("HR View")}
          </p>
        )}
        {(isHomePage || (!isMobileOrTablet && !isHomePage)) && (
          <LanguageSelector />
        )}
      </div>
    </div>
  );
}

export default Header;
